import { useState } from 'react';
import { theme } from '../styles/theme';
import { useProjectList, type ProjectItem } from '../lib/projectList';

type Props = {
  product: Omit<ProjectItem, 'qty'>;
  variant?: 'primary' | 'secondary' | 'compact';
  qty?: number;
};

/**
 * Botón para agregar un producto a la lista de proyecto.
 * Disponible también para visitantes; los precios profesionales siguen protegidos.
 * Muestra feedback visual al agregar.
 */
export function AddToProject({ product, variant = 'secondary', qty = 1 }: Props) {
  const { add } = useProjectList();
  const [added, setAdded] = useState(false);

  const onClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    add({ ...product, qty });
    setAdded(true);
    setTimeout(() => setAdded(false), 1400);
  };

  const styleByVariant: Record<typeof variant, React.CSSProperties> = {
    primary: {
      background: theme.brand,
      color: theme.textOnBrand,
      padding: '14px 24px',
      fontSize: 13,
      fontWeight: 700,
      textTransform: 'uppercase',
      letterSpacing: 0.4,
      border: 'none',
      cursor: 'pointer',
      fontFamily: theme.font.sans,
    },
    secondary: {
      background: theme.bg,
      color: theme.brand,
      padding: '12px 18px',
      fontSize: 12,
      fontWeight: 700,
      textTransform: 'uppercase',
      letterSpacing: 0.4,
      border: `1px solid ${theme.brand}`,
      cursor: 'pointer',
      fontFamily: theme.font.sans,
    },
    compact: {
      background: 'transparent',
      color: theme.brand,
      padding: '4px 0',
      fontSize: 11,
      fontWeight: 700,
      textTransform: 'uppercase',
      letterSpacing: 0.5,
      border: 'none',
      cursor: 'pointer',
      fontFamily: theme.font.sans,
    },
  };

  return (
    <button onClick={onClick} style={styleByVariant[variant]} aria-label="Agregar a cotización">
      {added ? '✓ Agregado' : '+ Agregar a cotización'}
    </button>
  );
}
